import { axios } from '../utilities';
import { PAGINATION } from '../../../shared/constants';

const loginUser = (email, password) => axios.post(
  'api/users/login',
  { email, password },
);

const getMe = () => axios.get('api/users/me');

const logoutUser = () => axios.post('api/users/logout');

const getUserById = userId => axios.get(`api/users/${userId}`);

const getMoreUsers = (
  match = {},
  project = {},
  sort = {},
  skip = 0,
  limit = 0,
  conditions = {},
) => axios.get(
  'api/users/more',
  {
    params: {
      match,
      project,
      sort,
      skip,
      limit,
      conditions,
    },
  },
);

const searchUsers = (
  match = {},
  project = {},
  sort = {},
  conditions = {},
) => axios.get(
  'api/users/search',
  {
    params: {
      match,
      project,
      sort,
      conditions,
    },
  },
);

const deleteUser = userId => axios.delete(`api/users/${userId}`, { params: { userId } });

const sendReinviteAfterExpire = userId => axios.post(`api/users/${userId}/reinvite`, { params: { userId } });

const updateUser = (
  userId,
  userAccount,
) => axios.put(
  `api/users/${userId}`,
  { account: { user: userAccount } },
);

const addUser = user => axios.post('api/users', { user });

const getUsers = (
  {
    nameOrMail,
    roles,
    countries,
    hasPhone,
    notRegistered,
    registered,
    writerWithKeyword,
    userStatuses,
    createFromDate,
    createToDate,
    lastLoggedInFromDate,
    lastLoggedInToDate,
  },
  { pageIndex, pageSize },
  sortBy = null,
) => axios.get('api/users', {
  params: {
    filters: {
      nameOrMail,
      roles,
      countries,
      hasPhone,
      notRegistered,
      registered,
      writerWithKeyword,
      userStatuses,
      createFromDate,
      createToDate,
      lastLoggedInFromDate,
      lastLoggedInToDate,
    },
    pagination: { pageIndex, pageSize },
    sortBy,
  },
});

const getUsersForExcel = (
  filters,
  sortBy = null,
) => axios.get(
  'api/users/users-for-excel',
  { params: { filters, sortBy } },
);

const getUserWithMiscData = (
  userId,
  { pageIndex, pageSize } = { pageIndex: PAGINATION.pageIndex, pageSize: PAGINATION.pageSize },
  shouldLoadMoreProjects,
) => axios.get(
  `/api/users/${userId}/misc-data`,
  {
    params: {
      pagination: { pageIndex, pageSize },
      shouldLoadMoreProjects,
    },
  },
);
const getOfflineWritersMatch = (
  { pageIndex, pageSize } = { pageIndex: PAGINATION.pageIndex, pageSize: PAGINATION.pageSize },
  sortBy,
  {
    nameOrEmail,
    levels,
    distances,
    genders,
    keywords,
    otherLanguages,
    otherInformation,
    writingStyle,
    comfortLevel,
    statuses,
    accreditedOnly,
    dbsScreenedOnly,
    country,
    zipCode,
    newWritersOnly,
    createFromDate,
    createToDate,
    lastLoggedInFromDate,
    lastLoggedInToDate,
  } = {},
) => axios.post(
  '/api/users/offline-writer-match',
  {},
  {
    params: {
      pagination: { pageIndex, pageSize },
      sortBy,
      filters: {
        nameOrEmail,
        levels,
        distances,
        genders,
        keywords,
        otherLanguages,
        otherInformation,
        writingStyle,
        comfortLevel,
        statuses,
        accreditedOnly,
        dbsScreenedOnly,
        country,
        zipCode,
        newWritersOnly,
        createFromDate,
        createToDate,
        lastLoggedInFromDate,
        lastLoggedInToDate,
      },
      isOfflineWriterMatch: true,
    },
  },
);

const getExcelOfflineWritersMatch = (
  sortBy,
  filters = {},
  address = {},
) => axios.post(
  '/api/users/excel-offline-writer-match',
  {},
  {
    params: {
      sortBy,
      filters,
      address,
      isOfflineWriterMatch: true,
    },
  },
);

const toggleArchivingUser = userId => axios.put(`api/users/${userId}/toggle-archiving`);

const passwordSetup = (token, password, isPolicyAccepted) =>
  axios.post(`api/users/password-setup/${token}`, { password, isPolicyAccepted });

const getUserByToken = token => axios.get(`api/users/info/${token}`);

const addAvatarPhoto = (userId, photo) => axios.put(`api/users/${userId}/add-avatar`, { photo });

const forgotPassword = email => axios.post('api/users/forgot-password', { email });

const updateHubspotProjectsCount = userId => axios.put(`api/users/${userId}/update-hubspot-projects-count`);

const updateWritersProjectCount = () => axios.post('api/users/update-writers-project-count', {}, { timeout: 60000 });

const updateWritersDBSScreened = () => axios.post('api/users/update-writers-dbs-screened', {}, { timeout: 60000 });

const askForInvitation = (token, email) => axios.post(`api/users/ask-for-invitation/${token}`, { email });

const updateUserInteractions = (userId, interactionKey) =>
  axios.put(`api/users/${userId}/update-interactions`, { interactionKey });

export default {
  loginUser,
  getMe,
  logoutUser,
  getUsers,
  getUsersForExcel,
  getUserById,
  getMoreUsers,
  searchUsers,
  deleteUser,
  sendReinviteAfterExpire,
  updateUser,
  addUser,
  getUserWithMiscData,
  getOfflineWritersMatch,
  toggleArchivingUser,
  passwordSetup,
  getUserByToken,
  addAvatarPhoto,
  getExcelOfflineWritersMatch,
  forgotPassword,
  updateHubspotProjectsCount,
  updateWritersProjectCount,
  updateWritersDBSScreened,
  askForInvitation,
  updateUserInteractions,
};
